export default __webpack_public_path__ + "static/media/Wave2-2.d82ea682.png";